import axios from "./userInstance";
import { toast } from "react-toastify";
import notifyError from "@/utils/notifyError";

interface ChangePasswordPayload {
  email: string;
  password: string;
}

export default async (payload: ChangePasswordPayload) => {
  try {
    const response = await axios.post(`/users/change-password-by-admin`, payload);
    toast.success(`Password changed successfully`)
    return response.data || true
  } catch (error: any) {
    notifyError(error, 'Failed to change password')
    return null
  }
}
